import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';
import { trigger, style, animate, transition } from '@angular/animations';


declare var $: any;
@Component({
  standalone: false,
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.scss'],
  animations: [
  trigger('fade', [
    transition('void => *', [
      style({ opacity: 0 }),
      animate(1300, style({ opacity: 1 }))
    ])
  ])
]
})
export class ReportComponent implements OnInit {
  message: string;
  road: number;
  showProgress = true;
  showProgress2 = true;

  constructor(private readonly reportService: ReportService, private readonly route: Router, private c: CommonsService) { }


  ngOnInit() {
    this.c.firstChargePage('Informe', 'Informe salud financiera', 'content');
    this.c.eventsAnalitics('visit screen', 'contenido de la vista Informe', 'Informe');
  }

  ReportMail(road) {
    this.showProgress = false;
    this.reportService.getReportMail(sessionStorage.getItem('t'), road).subscribe(data => {
      if (data.Code === 401) {
        this.c.openModalSession();
      } else {
        this.c.eventsAnalitics('conversion', 'Informe salud financiera', 'Envio de informe por correo');
        this.showProgress = true;
        this.message = data.Message;
        sessionStorage.setItem('t', data.Token);
      }
    },
      error => {
        this.showProgress = true;
        this.c.openModalSession();
      });
  }

  ReportDonwload(road) {
    this.showProgress2 = false;
    this.reportService.getReport(sessionStorage.getItem('t'), road).subscribe(
      data => {
        this.showProgress2 = true;
        this.c.eventsAnalitics('conversion', 'Informe salud financiera', 'Descarga de informe por correo');
        this.downloadFile(data);
      }, error => {
        this.showProgress2 = true;
        this.c.openModalSession();
      });
  }


  downloadFile(data: ResponseType) {
    this.message = 'Aquí tienes tu informe de salud financiera.';

    const blob = new Blob([data], { type: 'application/pdf' });
    const fileName = 'AKANA - Tu informe de salud financiera';
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

}
